export var helpCenterAccountApiRelativePath = '/account';
export var createHelpCenterAccountApi = function (baseUrl, http) {
    var helpCenterApiUrl = "".concat(baseUrl).concat(helpCenterAccountApiRelativePath, "/helpCenter");
    var ticketingApiUrl = "".concat(baseUrl).concat(helpCenterAccountApiRelativePath, "/helpCenterTicketsPage");
    return {
        isHelpCenterEnabled: function (dto) {
            return http.get("".concat(helpCenterApiUrl, "?id=").concat(dto.id));
        },
        enableHelpCenter: function (dto) {
            return http.post("".concat(helpCenterApiUrl, "/enable"), dto);
        },
        disableHelpCenter: function (dto) {
            return http.post("".concat(helpCenterApiUrl, "/disable"), dto);
        },
        isTicketingEnabled: function (dto) {
            return http.get("".concat(ticketingApiUrl, "?id=").concat(dto.brandId));
        },
        enableTicketing: function (dto) {
            return http.post("".concat(ticketingApiUrl, "/enable"), dto);
        },
        disableTicketing: function (dto) {
            return http.post("".concat(ticketingApiUrl, "/disable"), dto);
        },
    };
};
//# sourceMappingURL=index.js.map